import { useState, useEffect } from 'react';
import Button from './button';

const StickyMobileCTA = () => {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const checkVisibility = () => {
            const heroEl = document.getElementById('home');
            const formEl = document.getElementById('booking-form');
            const viewportHeight = window.innerHeight;

            // Hide when hero section CTA is still in view
            if (heroEl) {
                const heroRect = heroEl.getBoundingClientRect();
                if (heroRect.bottom > viewportHeight * 0.25) {
                    setVisible(false);
                    return;
                }
            }

            // Hide when 30% of booking form is visible
            if (formEl) {
                const formRect = formEl.getBoundingClientRect();
                const threshold = formRect.height * 0.3;
                const visiblePortion = Math.min(formRect.bottom, viewportHeight) - Math.max(formRect.top, 0);
                if (visiblePortion >= threshold) {
                    setVisible(false);
                    return;
                }
            }

            setVisible(true);
        };

        window.addEventListener('scroll', checkVisibility, { passive: true });
        checkVisibility();

        return () => window.removeEventListener('scroll', checkVisibility);
    }, []);

    const scrollToBooking = () => {
        const element = document.getElementById('booking-form');
        if (element) {
            const navbarHeight = 72;
            const y = element.getBoundingClientRect().top + window.scrollY - navbarHeight;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    return (
        <div
            className="sticky-mobile-cta"
            style={{
                transform: visible ? 'translateY(0)' : 'translateY(100%)',
                transition: 'transform 0.3s ease',
            }}
        >
            <Button type="primary" onClick={scrollToBooking} className="w-full">
                Book Free Discovery Session
            </Button>
        </div>
    );
};

export default StickyMobileCTA;
